import { Box, CircularProgress, Grid } from '@mui/material'

type Props = {
  message: string
  fullScreen?: boolean
}

export const PageLoader = ({ message, fullScreen = false }: Props) => {
  return (
    <Box sx={{ width: fullScreen ? '100vw' : '100%', height: fullScreen ? '100vh' : '100%' }}>
      <Grid
        container
        spacing={2}
        sx={{ height: '100%', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}
      >
        <Grid>
          <CircularProgress />
        </Grid>
        <Grid>{message}</Grid>
      </Grid>
    </Box>
  )
}
